import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import urlParser from "js-video-url-parser";

const messages = defineMessages({
    "templates.sections.form.edit.content.video.ratio_21_9_label": {
        id: 'templates.sections.form.edit.content.video.ratio_21_9_label',
        defaultMessage: '21:9',
    },
    "templates.sections.form.edit.content.video.ratio_16_9_label": {
        id: 'templates.sections.form.edit.content.video.ratio_16_9_label',
        defaultMessage: '16:9',
    },
    "templates.sections.form.edit.content.video.ratio_4_3_label": {
        id: 'templates.sections.form.edit.content.video.ratio_4_3_label',
        defaultMessage: '4:3',
    },
    "templates.sections.form.edit.content.video.ratio_1_1_label": {
        id: 'templates.sections.form.edit.content.video.ratio_1_1_label',
        defaultMessage: '1:1',
    },
    "templates.sections.form.edit.content.image.size_15_label": {
        id: 'templates.sections.form.edit.content.image.size_15_label',
        defaultMessage: '15%',
    },
    "templates.sections.form.edit.content.image.size_25_label": {
        id: 'templates.sections.form.edit.content.image.size_25_label',
        defaultMessage: "25%",
    },
    "templates.sections.form.edit.content.image.size_50_label": {
        id: 'templates.sections.form.edit.content.image.size_50_label',
        defaultMessage: "50%",
    },
    "templates.sections.form.edit.content.image.size_75_label": {
        id: 'templates.sections.form.edit.content.image.size_75_label',
        defaultMessage: "75%",
    },
    "templates.sections.form.edit.content.image.size_100_label": {
        id: 'templates.sections.form.edit.content.image.size_100_label',
        defaultMessage: "100%",
    },
    "templates.sections.form.edit.content.image.alignment_left_label": {
        id:"templates.sections.form.edit.content.image.alignment_left_label",
        defaultMessage:"Left"
    },
    "templates.sections.form.edit.content.image.alignment_center_label": {
        id:"templates.sections.form.edit.content.image.alignment_center_label",
        defaultMessage:"Center"
    },
    "templates.sections.form.edit.content.image.alignment_right_label": {
        id:"templates.sections.form.edit.content.image.alignment_right_label",
        defaultMessage:"Right"
    },
    "templates.sections.form.edit.content.video.url_placeholder": {
        id: 'templates.sections.form.edit.content.video.url_placeholder',
        defaultMessage: 'https://www.youtube.com/embed/nOZu0_Nqms0',
    },
})


class VideoContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            ratio:content.ratio || "16by9",
            url:content.url || "",
            embeddedURL:content.url || "", //the url that will be used to embed the video (might be an improvement of the user input)
            alignment: content.alignment || 'center',
            size: content.size || '25',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleUrlChange = this.handleUrlChange.bind(this)
        this.handleUrlInputFieldBlur = this.handleUrlInputFieldBlur.bind(this)
    }


    triggerChanged() {

        this.state.onChange({
            ratio:      this.state.ratio,
            url: this.state.embeddedURL,
            alignment: this.state.alignment,
            size: this.state.size,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            ratio: content.ratio || "16by9",
            url: content.url || "",
            alignment: content.alignment || 'center',
            size: content.size || '25',
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleUrlChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var embeddedURL = value
        if(embeddedURL) {
            var videoInfo = urlParser.parse(embeddedURL)
            if(videoInfo) {
                var customParams = videoInfo.params || {}

                //by default, let's not autoplay
                if (!customParams || !customParams.autoplay) {
                    customParams.autoplay = 0
                }
                else { //if autoplay is set, by default, let's not have sound otherwise some browsers will block the video
                    if (videoInfo.provider === 'youtube' && typeof customParams.mute === 'undefined') {
                        customParams.mute = 1
                    }
                    if (videoInfo.provider === 'vimeo' && typeof customParams.muted === 'undefined') {
                        customParams.muted = 1
                    }
                }
                //by default, let's not loop
                if (!customParams || !customParams.loop) {
                    customParams.loop = 0
                }

                //nice to have by default
                if ((!customParams || customParams.modestbranding) && videoInfo.provider === 'youtube') {
                    customParams.modestbranding = 1
                }

                embeddedURL = urlParser.create({
                    videoInfo: videoInfo,
                    format: 'embed',
                    params: customParams
                })
                embeddedURL = "https:" + embeddedURL
            }
        }

        this.setState({
            [name]: value,
            embeddedURL : embeddedURL
        })
    }

    handleUrlInputFieldBlur(event) {
        this.setState({
            url : this.state.embeddedURL,
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="url">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.video.url.label"
                            defaultMessage="URL of the video"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="url"
                            value={this.state.url}
                            onChange={this.handleUrlChange}
                            id="url"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage(messages['templates.sections.form.edit.content.video.url_placeholder'])}
                            onBlur={this.handleUrlInputFieldBlur}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.video.url"
                                defaultMessage="URL of the video from Youtube or Vimeo that will be embedded"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="size">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.image.size_label"
                            defaultMessage="Size"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="size"
                            value={this.state.size}
                            onChange={this.handleFormChange}
                            id="size"
                            className="form-control"
                        >
                            <option value="15">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_15_label"])}
                            </option>
                            <option value="25">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_25_label"])}
                            </option>
                            <option value="50">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_50_label"])}
                            </option>
                            <option value="75">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_75_label"])}
                            </option>
                            <option value="100">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_100_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.video.size_description"
                                defaultMessage="Size of the video player (percentage of the document width)"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="size">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.video.ratio_label"
                            defaultMessage="Ratio"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="ratio"
                            value={this.state.ratio}
                            onChange={this.handleFormChange}
                            id="ratio"
                            className="form-control"
                        >
                            <option value="21by9">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.video.ratio_21_9_label"])}
                            </option>
                            <option value="16by9">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.video.ratio_16_9_label"])}
                            </option>
                            <option value="4by3">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.video.ratio_4_3_label"])}
                            </option>
                            <option value="1by1">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.video.ratio_1_1_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.video.ratio_description"
                                defaultMessage="Aspect ratio of the video"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="alignment">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.image.alignment_label"
                            defaultMessage="Alignment"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="alignment"
                            value={this.state.alignment}
                            onChange={this.handleFormChange}
                            id="alignment"
                            className="form-control"
                        >
                            <option value="left">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_left_label"])}
                            </option>
                            <option value="center">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_center_label"])}
                            </option>
                            <option value="right">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_right_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.video.alignment_description"
                                defaultMessage="Horizontal alignment of the video player"
                            />
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(VideoContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/video/input.component.jsx